<template>
  <button class="start_button" @click="handleClick" :disabled="disabled">
    {{ buttonLabel }}
  </button>
</template>

<script>
export default {
  name: "FaceStartButton",
  props: {
    buttonLabel: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: null,
    },
  },
  methods: {
    handleClick() {
      this.$emit("clicked");
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  position: absolute;
  bottom: 25%;
  width: 95%;
  height: 50px;
  border: none;
  border-radius: 30px;
  background-color: #ffb206;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  box-shadow: var(--defaultBoxShadow);
}

button:disabled {
  background-color: gray;
}
</style>
